import { render, staticRenderFns } from "./report-found.vue?vue&type=template&id=bd5b1692"
import script from "./report-found.vue?vue&type=script&lang=js"
export * from "./report-found.vue?vue&type=script&lang=js"
import style0 from "./report-found.vue?vue&type=style&index=0&id=bd5b1692&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports